export default function formatDate(apiDate) {
  const date = new Date(apiDate);
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}


// export default function formatDate(apiDate) {
//   const date = new Date(apiDate);
//   if (isNaN(date.getTime())) return "Invalid date"; // handle safely
//   return date.toLocaleDateString("en-US", {
//     weekday: "long",
//     year: "numeric",
//     month: "long",
//     day: "numeric",
//   });
// }
